import { CreateStoryVersionMeta, CreateStoryVersionPayload } from 'types/store/CreateStoryVersion';
import { createAsyncReducer } from 'utils/Redux';

import { createStoryVersionActions } from '../actions';

export default createAsyncReducer<CreateStoryVersionMeta, CreateStoryVersionPayload>(createStoryVersionActions);
